import * as Sentry from "@sentry/react";

// Sentry DSN for the progress-admin project. Public by design — a DSN only permits WRITING
// events, so it ships in the client bundle the same way progress-coach hardcodes its own.
const SENTRY_DSN =
  "https://0634b2c7ef2963653ae32aa902823323@o4505602239102976.ingest.us.sentry.io/4511802944258048";

/**
 * Wire up Sentry once, before the first render.
 *
 * Deliberately environment-aware: local development is noisy (hot-reload errors, half-typed
 * code) and would drown the real signal, so events are only sent from a deployed build. Set
 * REACT_APP_SENTRY_FORCE=true to test the wiring from localhost.
 */
export function initSentry() {
  const forced = process.env.REACT_APP_SENTRY_FORCE === "true";
  if (!SENTRY_DSN || (process.env.NODE_ENV !== "production" && !forced)) return;

  Sentry.init({
    dsn: SENTRY_DSN,

    // Distinguishes admin-stg from admin in the Sentry UI, so stage noise can be filtered out
    // of production alerting. REACT_APP_ENV is set per build (.env.stage / .env.production).
    environment: process.env.REACT_APP_ENV || "production",

    // Matches progress-coach: attaches IP / user context so an error can be traced to a company.
    sendDefaultPii: true,

    // Catches what the React error boundary structurally cannot — errors thrown in event
    // handlers, async callbacks, and unhandled promise rejections.
    integrations: [Sentry.browserTracingIntegration()],

    // Performance sampling. 10% keeps the quota sane; errors are ALWAYS sent at 100% regardless
    // (tracesSampleRate only governs performance transactions, not exceptions).
    tracesSampleRate: 0.1,
  });
}

/**
 * Tag events with who hit them. Without this an error is anonymous and we can't tell whether one
 * company is broken or everyone is. Called on login / identity change.
 */
export function setSentryUser(user) {
  if (!SENTRY_DSN) return;
  if (!user) {
    Sentry.setUser(null);
    return;
  }
  Sentry.setUser({
    id: user.id,
    email: user.email,
    // The company is the unit we triage by — "is this one tenant or the whole platform?"
    companyId: user.companyId,
  });
}
